import { useMemo } from 'react';
import { ConfirmationModal } from 'shared/components/ConfirmationModal';
import { SynchronizationActionEnum } from 'order/enums/SynchronisationActionEnum';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useHasPermissions } from 'shared/hooks/useHasPermissions';
import { userPermissionsValues } from 'shared/enum/userPermissionsEnum';
import { useAppDispatch } from 'shared/hooks/useAppDispatch';
import { cleanSyncToolFailNotification } from 'notifications/store/notificationsActions';

export const SyncToolPopUp = () => {
  const order = useSelector((state: RootState) => state.orderReducer.order);
  const currentUser = useSelector((state: RootState) => state.authReducer.user);
  const dispatch = useAppDispatch();

  const { syncToolFailNotification } = useSelector(
    (state: RootState) => state.notificationsReducer
  );
  const isUserCSR = useHasPermissions(
    userPermissionsValues.CSR_VIEW_ORDERBOARD
  );

  /** Checks if the current user is related to the order. */
  const isCurrentUserRelatedToOrder = useMemo(() => {
    if (!order || !currentUser) return false;
    const { id } = currentUser;
    return (
      order.creatorId === id ||
      order.creator?.id === id ||
      order.ownerId === id ||
      order.owner?.id === id ||
      order.orderedById === id ||
      order.orderedBy?.id === id ||
      order.assigneeIds?.includes(id) === true ||
      order.assigneeResponses?.some((a) => a.id === id) === true
    );
  }, [order, currentUser]);

  const text = syncToolFailNotification
    ? `${syncToolFailNotification.content} Please inform system administrators, and await further instructions.`
    : `Please stop editing this work order #${
        order?.serialNumber
      }. A sync error ${
        order?.synchronizationStatus?.failure?.action
          ? SynchronizationActionEnum[
              order!.synchronizationStatus!.failure!.action
            ]
          : ''
      } has occurred. Please inform system administrators, and await further instructions.`;

  return (
    <ConfirmationModal
      confirm={(close: () => void) => {
        dispatch(cleanSyncToolFailNotification());
        close();
      }}
      buttonText="OK"
      shouldNotRenderCancelButton
      title="Warning"
      message={text}
      opened={
        isUserCSR &&
        isCurrentUserRelatedToOrder &&
        order !== null &&
        (syncToolFailNotification !== null ||
          order.synchronizationStatus?.failure !== null)
      }
    />
  );
};
